import { ModuleWithProviders } from "@angular/core";
import { ExtraOptions, RouterModule, Routes, PreloadAllModules } from "@angular/router";
import { AppConstants } from "./shared/constants/app.contants";
import { NavBarComponent } from "./core/nav-bar/nav-bar.component";
import { AuthGuard } from "./shared/guards/auth.guard";
import { TcaRoleGuard } from "./shared/guards/tca-role.guard";
import { HomeComponent } from "./core/home/home.component";
import { ApprovedPRsComponent } from "./core/approved-prs/approved-prs.component";
import { PRDetailsComponent } from "./core/approved-prs/pr-details/pr-details.component";
import { TendersComponent } from "./core/tenders/tenders.component";
import { TenderDetailsComponent } from "./core/tenders/tender-details/tender-details.component";
import { CreateTenderComponent } from "./core/tenders/create-tender/create-tender.component";
import { PracticesComponent } from "./core/practices/practices.component";
import { PracticeDetailsComponent } from "./core/practices/practice-details/practice-details.component";
import { BidsComponent } from "./core/bids/bids.component";
import { BidDetailsComponent } from "./core/bids/bid-details/bid-details.component";
import { EvaluationsComponent } from "./core/evaluations/evaluations.component";
import { AssignEvaluatorsComponent } from "./core/evaluations/assign-evaluators/assign-evaluators.component";
import { EvaluationScoringComponent } from "./core/evaluations/evaluation-scoring/evaluation-scoring.component";
import { EvaluationDetailsComponent } from "./core/evaluations/evaluation-details/evaluation-details.component";
import { MeetingsComponent } from "./core/meetings/meetings.component";
import { CreateMeetingComponent } from "./core/meetings/create-meeting/create-meeting.component";
import { ViewMeetingComponent } from "./core/meetings/view-meeting/view-meeting.component";
import { MinutesOfMeetingComponent } from "./core/minutes-of-meeting/minutes-of-meeting.component";
import { MinutesOfMeetingDetailsComponent } from "./core/minutes-of-meeting/minutes-of-meeting-details/minutes-of-meeting-details.component";
import { AgendaItemsComponent } from "./core/agenda-items/agenda-items.component";
import { FAQsComponent } from "./core/faqs/faqs.component";
import { ViewFAQComponent } from "./core/faqs/view-faq/view-faq.component";
import { VendorsComponent } from "./core/vendors/vendors.component";
import { VendorDetailsComponent } from "./core/vendors/vendor-details/vendor-details.component";
import { LookupsComponent } from "./core/lookups/lookups.component";
import { UserManagementComponent } from "./core/user-management/user-management.component";

const routerOptions: ExtraOptions = {
    scrollPositionRestoration: "enabled",
    anchorScrolling: "enabled",
    scrollOffset: [0, 64],
    preloadingStrategy: PreloadAllModules
};

export const routes: Routes = [
    {
        path: `vendor-task/:vendorId`,
        component: VendorDetailsComponent
    },
    {
        path: '',
        component: NavBarComponent,
        canActivate: [AuthGuard, TcaRoleGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                component: HomeComponent
            },
            {
                path: AppConstants.ROUTES.HOME,
                pathMatch: 'full',
                component: HomeComponent
            },
            {
                path: AppConstants.ROUTES.APPROVED_PRS,
                pathMatch: 'full',
                component: ApprovedPRsComponent
            },
            {
                path: `${AppConstants.ROUTES.APPROVED_PRS}/${AppConstants.ROUTES.PRDETAILS}/:id`,
                component: PRDetailsComponent
            },
            {
                path: AppConstants.ROUTES.TENDER,
                pathMatch: 'full',
                component: TendersComponent
            },
            {
                path: `${AppConstants.ROUTES.TENDER}/${AppConstants.ROUTES.CREATE_TENDER}`,
                pathMatch: 'full',
                component: CreateTenderComponent
            },
            {
                path: `${AppConstants.ROUTES.TENDER}/${AppConstants.ROUTES.TENDERDETAILS}/:id`,
                component: TenderDetailsComponent
            },
            {
                path: AppConstants.ROUTES.PRACTICE,
                pathMatch: 'full',
                component: PracticesComponent
            },
            {
                path: `${AppConstants.ROUTES.PRACTICE}/${AppConstants.ROUTES.CREATE_PRACTICE}`,
                pathMatch: 'full',
                component: CreateTenderComponent
            },
            {
                path: `${AppConstants.ROUTES.PRACTICE}/${AppConstants.ROUTES.PRACTICEDETAILS}/:id`,
                component: PracticeDetailsComponent
            },
            {
                path: AppConstants.ROUTES.FWA_PRACTICE,
                pathMatch: 'full',
                component: TendersComponent
            },
            {
                path: `${AppConstants.ROUTES.FWA_PRACTICE}/${AppConstants.ROUTES.CREATE_PRACTICE}`,
                pathMatch: 'full',
                component: CreateTenderComponent
            },
            {
                path: `${AppConstants.ROUTES.FWA_PRACTICE}/${AppConstants.ROUTES.PRACTICEDETAILS}/:id`,
                component: TenderDetailsComponent
            },
            {
                path: AppConstants.ROUTES.BID,
                pathMatch: 'full',
                component: BidsComponent
            },
            {
                path: `${AppConstants.ROUTES.BID}/${AppConstants.ROUTES.BIDDETAILS}/:id`,
                component: BidDetailsComponent
            },
            {
                path: AppConstants.ROUTES.EVALUATIONS,
                pathMatch: 'full',
                component: EvaluationsComponent
            },
            {
                path: `${AppConstants.ROUTES.EVALUATIONS}/${AppConstants.ROUTES.ASSIGN_EVALUATORS}`,
                pathMatch: 'full',
                component: AssignEvaluatorsComponent
            },
            {
                path: `${AppConstants.ROUTES.EVALUATIONS}/${AppConstants.ROUTES.EVALUATION_SCORING}`,
                pathMatch: 'full',
                component: EvaluationScoringComponent
            },
            {
                path: `${AppConstants.ROUTES.EVALUATIONS}/${AppConstants.ROUTES.EVALUATION_DETAILS}/:id`,
                component: EvaluationDetailsComponent
            },
            {
                path: AppConstants.ROUTES.MEETINGS,
                pathMatch: 'full',
                component: MeetingsComponent
            },
            {
                path: `${AppConstants.ROUTES.MEETINGS}/${AppConstants.ROUTES.CREATE_MEETING}`,
                pathMatch: 'full',
                component: CreateMeetingComponent
            },
            {
                path: `${AppConstants.ROUTES.MEETINGS}/${AppConstants.ROUTES.VIEW_MEETING}/:id`,
                component: ViewMeetingComponent
            },
            {
                path: AppConstants.ROUTES.MINUTES_OF_MEETING,
                pathMatch: 'full',
                component: MinutesOfMeetingComponent
            },
            {
                path: `${AppConstants.ROUTES.MINUTES_OF_MEETING}/${AppConstants.ROUTES.MINUTES_OF_MEETING_DETAILS}/:id`,
                component: MinutesOfMeetingDetailsComponent
            },
            {
                path: AppConstants.ROUTES.AGENDA_ITEMS,
                pathMatch: 'full',
                component: AgendaItemsComponent
            },
            {
                path: AppConstants.ROUTES.FAQS,
                pathMatch: 'full',
                component: FAQsComponent
            },
            {
                path: `${AppConstants.ROUTES.FAQS}/${AppConstants.ROUTES.VIEW_FAQ}/:id`,
                component: ViewFAQComponent
            },
            {
                path: AppConstants.ROUTES.VENDORS,
                pathMatch: 'full',
                component: VendorsComponent
            },
            {
                path: `${AppConstants.ROUTES.VENDORS}/${AppConstants.ROUTES.VENDOR_DETAILS}/:vendorId`,
                component: VendorDetailsComponent
            },
            {
                path: AppConstants.ROUTES.LOOKUPS,
                pathMatch: 'full',
                component: LookupsComponent
            },
            {
                path: AppConstants.ROUTES.USER_MANAGEMENT,
                pathMatch: 'full',
                component: UserManagementComponent
            }
        ]
    },
    {
        path: AppConstants.ROUTES.AUTHENTICATION,
        loadChildren: () => import('./modules/authentication/authentication.module').then(m => m.AuthenticationModule)
    },
    {
        path: '**',
        redirectTo: ''
    }
]

export const APP_ROUTES: ModuleWithProviders<any> = RouterModule.forRoot(routes, routerOptions);
